export { ConsentPopup } from "./ConsentPopup";
export { default } from "./ConsentPopup";
